import React from 'react';

// antd
import { Select, Form } from 'antd';
import type { DefaultOptionType, LabeledValue, SelectProps } from 'antd/es/select';
import type { Rule } from 'antd/es/form';

import './formSelectArray.scss';
const { Option } = Select;
const { Item } = Form;
type FilterFunc = SelectProps['filterOption'];

type FormSelectComponentArrayParams = {
    name:string
    rules?:Rule[]
    className?:string
    placeholder?:string
    dataList: {id:number, text:string}[]
    loading?:boolean
    optionFilterProp?:string
    showSearch:boolean
    filterOption?: FilterFunc
    filterSort: (optionA:DefaultOptionType, optionB:DefaultOptionType) => number
    handleFormValueschange?: (changedValues: any, allValues?: any) => void 
    mode?: 'multiple'|'tags'
    disabled?:boolean
    labelInValue?:boolean
    onSelect?: (value: string | number | LabeledValue, option: DefaultOptionType) => void;
}

const FormSelectComponentArray = ({
    name,
    rules,
    className,
    placeholder,
    dataList,
    loading = false,
    optionFilterProp = 'children',
    showSearch = true,
    filterOption = (input, option?) => String(option?.children ?? '').toLowerCase().includes(input.toLowerCase()),
    filterSort = (optionA, optionB) => String(optionA?.children ?? '').toLowerCase().localeCompare(String(optionB?.children ?? '').toLowerCase()),
    handleFormValueschange,
    mode,
    disabled,
    labelInValue = false,
    onSelect
}:FormSelectComponentArrayParams) => {
    
    return (
        <Item name={name} rules={rules} className={className}>
            <Select
                mode={mode}
                // name={name}
                placeholder={placeholder}
                loading={loading}
                filterOption={filterOption}
                filterSort={filterSort}
                showSearch={showSearch}
                optionFilterProp={optionFilterProp}
                onChange={(value, option) => {
                    // Supports multiple or single
                    const selectedOption = Array.isArray(option) ? option : [option];
                    const selectedObj = selectedOption.map((o) => o?.obj);
                    handleFormValueschange && handleFormValueschange({ [name + 'Obj']: selectedObj });
                }}
                disabled={disabled}
                labelInValue={labelInValue}
                onSelect={onSelect}
            >
                {dataList?.length &&
                    dataList.map((item) => {
                        return (
                            <Option key={item?.id} value={item?.text} obj={item}>
                                {item?.text}
                            </Option>
                        );
                    })}
            </Select>
        </Item>
    );
};

export default FormSelectComponentArray;
